import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AnnouncementService } from '@insolution/announcement-data-access';
import { AnnouncementForm } from '@insolution/announcement-ui';
import { CreateAnnouncementInput } from '@insolution/graphql-data-access';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-create-announcement-page',
  imports: [AnnouncementForm, TranslatePipe],
  templateUrl: './create-announcement-page.html',
  styleUrl: './create-announcement-page.scss',
})
export class CreateAnnouncementPage {
  private announcementService = inject(AnnouncementService);
  private router = inject(Router);

  protected isSaving = signal(false);

  protected async onSave(input: CreateAnnouncementInput): Promise<void> {
    this.isSaving.set(true);

    try {
      await this.announcementService.createAnnouncement(input);
      await this.router.navigate(['/announcements']);
    } finally {
      this.isSaving.set(false);
    }
  }

  protected onCancel(): void {
    this.router.navigate(['/announcements']);
  }
}
